import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: '50 JUGADAS GANADORAS PARA ZURDOS',
  subtitle: 'Secuencias listas para copiar',
  items: ['Saque + víbora', 'Globo + recuperación', 'Smash + cierre', 'Patrones rápidos']
}, {
  id: 2,
  title: 'PLAN DE ENTRENAMIENTO DE 90 DÍAS',
  subtitle: 'Sistema progresivo paso a paso',
  items: ['Semana por semana', 'Técnica + Físico', 'Táctica + Mentalidad']
}, {
  id: 3,
  title: 'EL MANUAL DEL ZURDO INCÓMODO',
  subtitle: 'Hacé que los rivales jueguen mal aunque sean técnicamente mejores.',
  items: []
}];
export function Bonuses() {
  return <section className="py-14 px-4 bg-brand-black text-white relative overflow-hidden" data-id="element-13">
      <div className="absolute top-0 right-0 w-72 h-72 bg-brand-green/10 rounded-full blur-[100px] pointer-events-none" data-id="element-14"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-15">
        <div className="text-center mb-10" data-id="element-16">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-green text-brand-black font-body font-bold text-xs tracking-wider uppercase mb-3" data-id="element-17">
            Gratis solo por hoy
          </span>
          <h2 className="font-display text-2xl md:text-4xl uppercase mb-2" data-id="element-18">
            Además, te llevás <span className="text-brand-green" data-id="element-19">3 BONOS</span>{' '}
            de regalo
          </h2>
          <p className="font-body text-sm md:text-base text-gray-400" data-id="element-20">
            Complementos perfectos para acelerar tus resultados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-21">
          {bonuses.map((bono, index) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-brand-card border border-white/10 rounded-xl p-5 hover:border-brand-green/40 transition-colors relative" data-id="element-22">
              <div className="flex items-center gap-2 mb-3" data-id="element-23">
                <div className="bg-brand-green text-brand-black font-display px-2.5 py-0.5 rounded text-xs" data-id="element-24">
                  BONO {bono.id}
                </div>
                <Gift className="w-4 h-4 text-brand-green" data-id="element-25" />
              </div>
              <h3 className="font-display text-base md:text-lg mb-1.5 leading-tight uppercase" data-id="element-26">
                {bono.title}
              </h3>
              <p className="font-body text-xs text-gray-400 mb-3 font-medium" data-id="element-27">
                {bono.subtitle}
              </p>

              {bono.items.length > 0 && <ul className="space-y-1.5" data-id="element-28">
                  {bono.items.map((item, i) => <li key={i} className="font-body text-xs text-gray-300 flex items-center gap-2" data-id="element-29">
                      <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0" data-id="element-30" />
                      {item}
                    </li>)}
                </ul>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}